import { AllotmentNode } from '@photocarbone/nooco-shared-api-def';
import { ALLOTMENT_IDS } from '../../globalVariable/typeProject';

export type GlobalData = {
  allotmentNodes: Map<number, AllotmentNode>;
};

// MyClass.js
class GlobalDataWrapper {
  allotmentNodes: Map<number, AllotmentNode>;

  constructor(allotmentNodesMap: Map<number, AllotmentNode>) {
    this.allotmentNodes = allotmentNodesMap;
  }

  getAllAllotmentNodesNoocoAtLvl4() {
    const entriesArray = Array.from(this.allotmentNodes.entries());

    // Filter the array based on the condition
    const filteredArray = entriesArray.filter(
      ([key, node]) => node.level === 4 && node.AllotmentId === ALLOTMENT_IDS.NOOCO
    );

    // Convert the filtered array back to a Map
    const filteredMap = new Map(filteredArray);

    return filteredMap;
  }
}

export default GlobalDataWrapper;
